import { AlertFirma } from "../componentesGenerales/alertFirma";

export const SuccessMessage = () => {
  return <AlertFirma title={""} severity="success" />;
};
